@let videoSection = videoSection$ | async;
@let client = client$ | async;
@let isAuthor = client?.id === videoSection?.author?.id || client?.is_admin;
@let coordinates = coordinates$ | async;

<app-generic-view
  [backgroundImage]="
    'url(' +
    (videoSection?.thumbnails?.medium ||
      '/assets/images/workout-background-img/img_cycling_1.jpg') +
    ')'
  "
  [information]="videoSection"
  [comments$]="comments$"
  [showRanking]="true"
  [top3$]="top3$"
  [stravaSections$]="stravaSections$"
  (getComments)="getComments()"
  (getTop3)="getTop3()"
  (onLikeClick)="onLikeClick($event)"
  (onDownloadClick)="onDownloadGPX()"
  (onEditPost)="changeScenicData(videoSection.id, $event)"
  [editLoading$]="editLoading$">
  <kin-scenic-player
    id="kin-workout-player"
    [informations$]="videoSection$"
    [coodinates$]="coordinates$"
    [trainingSection$]="trainingSections$"
    [isAuthor]="isAuthor"
    [isSyncMode]="isSyncMode"
    [isSyncLoading]="isSyncLoading"
    (onSyncClick)="onSyncClick($event)"
    (onFavoriteClick)="onFavoriteClick(videoSection)"
    (thumbnailEditClick)="onThumbnailEditClick($event, videoSection.hash_id)" />
</app-generic-view>
